module.exports = "/components/directives/searchLookup-fa3a3b.html";